import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_TransportationPermissionSlip = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_TransportationPermissionSlip' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    This permission slip must be signed by the parent or guardian of the child. If you do not give permission,
                    please indicate in the appropriate space of the form. <br /> <br />
                    <b>TO BE SIGNED BY CLIENT/PARENT/LEGAL GUARDIAN</b> <br /> <br />
                    I hereby give my full permission to Life Solutions South to have client named above transported. <br />  <br />

                </p>


                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Parent/Legal Guardian Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>I do <b> NOT</b> give permission to Life Solutions South to have client named above transported.</p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Parent/Legal Guardian Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
            </div>
        </form>

    )
}